module.exports = __webpack_public_path__ + "static/media/attendance-queda-default-sound.0d1fd971.mp3";